import React, { useEffect, useState, useRef } from "react";
import '../../../styles/Auth/purchase.css';
import { X } from "lucide-react";
import { postData, getData, putData, deleteData } from '../../../webService/webservice.js'

const ViewPurchasePopup = ({ data, onClose }) => {
    const sessionToken = sessionStorage.getItem("sessionToken");
    const [showReturnForm, setShowReturnForm] = useState(false);
    const [returnData, setReturnData] = useState(null);
    const [returnHistory, setReturnHistory] = useState([]);

    useEffect(() => {
        if (data && data._id) {
            
            loadReturnHistory(data._id);
        }
    }, [data]);

    if (!data) return null;

    const {
        supplierId,
        purchaseInvoiceNumber,
        purchaseInvoiceAmount,
        purchaseInvoiceDate,
        products
    } = data;

    // ------------------------------
    // OPEN RETURN FORM
    // ------------------------------
    const handleOpenReturnForm = (prod) => {
        setReturnData({
            supplierName: supplierId?.supplierName,
            supplierId: supplierId?._id,
            invoiceNumber: purchaseInvoiceNumber,
            purchaseId: data?._id,
            productId: prod.productId?._id,
            productName: prod.productId?.title,
            purchasePrice: prod.purchasePrice,
            maxQuantity: prod.purchaseQuantity,
            returnQuantity: prod.purchaseQuantity,
            reason: ""
        });
        setShowReturnForm(true);
    };

    const handleChange = (e) => {
        setReturnData({ ...returnData, [e.target.name]: e.target.value });
    };

    const loadReturnHistory = async () => {
        try {
            const response = await getData(`purchasereturns/list/${data?._id}`, sessionToken);

            // Backend returns data as a flat array -> response.data
            setReturnHistory(response?.data || []);

        } catch (error) {
            console.log("Error loading return history", error);
        }
    };

    // ------------------------------
    // SUBMIT PURCHASE RETURN
    // ------------------------------
    const submitPurchaseReturn = async () => {
        const payload = {
            purchaseId: returnData.purchaseId,
            supplierId: returnData.supplierId,
            returnItems: [
                {
                    productId: returnData.productId,
                    quantity: Number(returnData.returnQuantity),
                    reason: returnData.reason,
                    purchasePrice: returnData.purchasePrice
                }
            ]
        };

        console.log("RETURN PAYLOAD", payload);
        
        try {
            const response = await postData("purchasereturns/", payload, sessionToken);
            alert("Purchase Return Added Successfully!");
            setShowReturnForm(false);
            loadReturnHistory();
        } catch (err) {
            console.error(err);
            alert(err.response?.data?.message || "Something went wrong");
        }
    };

    return (
        <div className="view-popup-overlay">
            <div className="purchase-view-popup-wrapper modern-popup">
                <div className="view-popup-header modern-header">
                    <h2>{showReturnForm ? "Purchase Return" : "Purchase Details"}</h2>
                    <X className="close-icon" onClick={onClose} />
                </div>

                {/* ------------------------------ */}
                {/* RETURN FORM SECTION             */}
                {/* ------------------------------ */}
                {showReturnForm && returnData ? (
                    <div className="return-form">

                        <div className="info-row">
                            <span>Supplier</span>
                            <strong>{returnData.supplierName}</strong>
                        </div>

                        <div className="info-row">
                            <span>Invoice No</span>
                            <strong>{returnData.invoiceNumber}</strong>
                        </div>

                        <div className="info-row">
                            <span>Product</span>
                            <strong>{returnData.productName}</strong>
                        </div>

                        <div className="info-row">
                            <span>Purchase Price</span>
                            <strong>₹{returnData.purchasePrice}</strong>
                        </div>
                        <div className="info-row">
                            <span>Quantity</span>
                            <strong>{returnData.maxQuantity}</strong>
                        </div>
                        <div className="info-row">
                            <span>Return Quantity</span>
                            <input
                                type="number"
                                name="returnQuantity"
                                min={1}
                                max={returnData.maxQuantity}
                                value={returnData.returnQuantity}
                                onChange={handleChange}
                                className="input"
                            />
                        </div>

                        <div className="info-row">
                            <span>Reason</span>
                            <textarea
                                name="reason"
                                value={returnData.reason}
                                onChange={handleChange}
                                className="textarea"
                                placeholder="Enter reason for return"
                            />
                        </div>

                        <div className="btn-group">
                            <button
                                className="btn-secondary"
                                onClick={() => setShowReturnForm(false)}
                            >
                                Back
                            </button>

                            <button
                                className="btn-primary"
                                onClick={submitPurchaseReturn}
                            >
                                Submit Return
                            </button>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="view-popup-content">

                            {/* Supplier + Purchase Info */}
                            <div className="info-grid">
                                <section className="popup-card">
                                    <h3 className="section-title">Supplier Information</h3>
                                    <div className="info-row"><span>Name</span><strong>{supplierId?.supplierName}</strong></div>
                                    <div className="info-row"><span>Mobile</span><strong>{supplierId?.mobileNumber}</strong></div>
                                    <div className="info-row"><span>Email</span><strong>{supplierId?.email}</strong></div>
                                </section>

                                <section className="popup-card">
                                    <h3 className="section-title">Purchase Information</h3>
                                    <div className="info-row"><span>Invoice Number</span><strong>{purchaseInvoiceNumber}</strong></div>
                                    <div className="info-row"><span>Amount</span><strong>₹{purchaseInvoiceAmount}</strong></div>
                                    <div className="info-row"><span>Date</span><strong>{new Date(purchaseInvoiceDate).toLocaleDateString()}</strong></div>
                                    <div className="info-row"><span>Total Quantity</span><strong>{products?.[0]?.purchaseQuantity}</strong></div>
                                </section>
                            </div>

                            {/* PRODUCT TABLE */}
                            <section className="popup-card full-width">
                                <h3 className="section-title">Product Details</h3>

                                <table className="modern-table">
                                    <thead>
                                        <tr>
                                            <th>Product Name</th>
                                            <th>Attributes</th>
                                            <th>Quantity</th>
                                            <th>Purchase Price</th>
                                            <th>Selling Price</th>
                                            <th>Total</th>
                                            <th>Return</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {products.map((prod, i) => {
                                            const p = prod.productId;

                                            const totalAmount =
                                                prod.purchasePrice *
                                                (prod.attributes?.[0]?.values?.[0]?.quantity ||
                                                    prod.purchaseQuantity);

                                            return (
                                                <tr key={i}>
                                                    <td>{p?.title}</td>
                                                    <td>
                                                        {prod.attributes?.length ? (
                                                            prod.attributes.map(attr =>
                                                                attr.values.map((v, idx) => (
                                                                    <span key={idx} className="tag">
                                                                        {v.name} ({v.quantity})
                                                                    </span>
                                                                ))
                                                            )
                                                        ) : "-"}
                                                    </td>

                                                    <td>{prod.purchaseQuantity}</td>
                                                    <td>₹{prod.purchasePrice}</td>
                                                    <td>₹{prod.sellingPrice}</td>
                                                    <td>₹{totalAmount}</td>

                                                    <td>
                                                        <button
                                                            className="btn-return"
                                                            onClick={() => handleOpenReturnForm(prod)}
                                                        >
                                                            Return
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </section>
                            {/* PURCHASE RETURN HISTORY */}
                            {returnHistory && returnHistory.length > 0 && (
                            <section className="popup-card full-width" style={{ marginTop: "20px" }}>
                                <h3 className="section-title">Purchase Return History</h3>

                                <table className="modern-table">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Product</th>
                                            <th>Returned Qty</th>
                                            <th>Price</th>
                                            <th>Total</th>
                                            <th>Reason</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {returnHistory.map((ret, index) => (
                                            <tr key={ret._id || index}>
                                                <td>{new Date(ret.createdAt).toLocaleDateString()}</td>
                                                <td>{ret.productId?.title || "-"}</td>
                                                <td>{ret.quantity}</td>
                                                <td>₹{ret.purchasePrice}</td>
                                                <td>₹{ret.totalAmount}</td>
                                                <td>{ret.reason || "-"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </section>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ViewPurchasePopup;
